var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVila(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 246.111,
    height: 82.932,
    viewBox: "0 0 246.111 82.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.008,
    y1: -0.092,
    x2: -0.379,
    y2: 1.215,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#009658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#009255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#008a50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#007f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#007140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#006036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#004d2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#004123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -3.933,
    x2: 0.5,
    y2: 4.389,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#009456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#008a50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#007a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#006337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#004827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.115,
    y1: -1.161,
    x2: 0.205,
    y2: 1.15,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#009658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#009154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#00884e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#007b46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#006b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#005831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#004224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004123"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-vila",
    transform: "translate(-32.63 -2.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    transform: "translate(32.63 2.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(140.637 73.744)",
    fill: "#717171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_17",
    "data-name": "Caminho 17",
    d: "M109.62 42.75h3.452a5.32 5.32 0 011.9.329 4.292 4.292 0 012.466 2.32 4.525 4.525 0 01.347 1.735v.018a4.209 4.209 0 01-.347 1.735 3.96 3.96 0 01-.968 1.407 4.331 4.331 0 01-1.5.932 5.323 5.323 0 01-1.9.347h-3.45zm1.936 1.772v5.3h1.5a2.9 2.9 0 001.078-.183 2.393 2.393 0 00.84-.548 2.5 2.5 0 00.548-.822 2.834 2.834 0 00.2-1.078v-.018a2.976 2.976 0 00-.2-1.078 2.435 2.435 0 00-1.388-1.388 2.976 2.976 0 00-1.078-.2h-1.5z",
    transform: "translate(-109.62 -42.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_18",
    "data-name": "Caminho 18",
    d: "M115.02 42.75h6.649v1.735h-4.731v1.79h4.162v1.735h-4.165v1.863h4.8v1.735h-6.715z",
    transform: "translate(-105.156 -42.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M123.083 51.76a5.788 5.788 0 01-1.991-.347 5.511 5.511 0 01-1.772-1.059l1.151-1.37a6.127 6.127 0 001.242.785 3.208 3.208 0 001.388.292 1.783 1.783 0 00.95-.219.7.7 0 00.329-.621V49.2a.626.626 0 00-.073-.329.775.775 0 00-.274-.274 2.6 2.6 0 00-.548-.256c-.237-.091-.53-.164-.9-.274a12.014 12.014 0 01-1.206-.365 2.886 2.886 0 01-.913-.493 1.889 1.889 0 01-.585-.731 2.45 2.45 0 01-.2-1.1v-.018a2.669 2.669 0 01.219-1.1 2.4 2.4 0 01.639-.84 2.964 2.964 0 01.968-.548 3.853 3.853 0 011.242-.183 5.185 5.185 0 011.79.292 5.263 5.263 0 011.5.84l-1 1.461a6.777 6.777 0 00-1.169-.639 2.8 2.8 0 00-1.133-.237 1.417 1.417 0 00-.859.219.694.694 0 00-.292.548v.027a.724.724 0 00.073.365.743.743 0 00.292.292 2.575 2.575 0 00.585.237l.95.274a11.224 11.224 0 011.187.4 3.389 3.389 0 01.877.53 2.139 2.139 0 01.548.731 2.353 2.353 0 01.183 1v.018a2.676 2.676 0 01-.237 1.169 2.565 2.565 0 01-.658.859 3.019 3.019 0 01-1.023.53 5.353 5.353 0 01-1.28.155z",
    transform: "translate(-101.601 -42.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20",
    "data-name": "Caminho 20",
    d: "M124.08 42.75h3.452a5.249 5.249 0 011.9.329A4.292 4.292 0 01131.9 45.4a4.525 4.525 0 01.347 1.735v.018a4.208 4.208 0 01-.347 1.735 3.96 3.96 0 01-.968 1.407 4.331 4.331 0 01-1.5.932 5.323 5.323 0 01-1.9.347h-3.452zm1.955 1.772v5.3h1.5a2.9 2.9 0 001.078-.183 2.393 2.393 0 00.84-.548 2.5 2.5 0 00.548-.822 2.834 2.834 0 00.2-1.078v-.018a2.976 2.976 0 00-.2-1.078 2.435 2.435 0 00-1.391-1.395 2.976 2.976 0 00-1.078-.2h-1.5z",
    transform: "translate(-97.666 -42.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_21",
    "data-name": "Caminho 21",
    d: "M129.49 42.75h6.649v1.735h-4.731v1.79h4.165v1.735h-4.165v1.863h4.8v1.735h-6.718V42.75z",
    transform: "translate(-93.194 -42.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22",
    "data-name": "Caminho 22",
    d: "M137.735 44.693l-1.553.365-.4-1.589 2.539-.749h1.333v8.914h-1.918v-6.941z",
    transform: "translate(-87.994 -42.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_23",
    "data-name": "Caminho 23",
    d: "M142.072 50.05a1.681 1.681 0 00.84-.2 1.775 1.775 0 00.53-.511 2.718 2.718 0 00.311-.658 3.045 3.045 0 00.128-.639 2.4 2.4 0 01-.785.457 2.9 2.9 0 01-1 .164 4.111 4.111 0 01-1.3-.2 2.866 2.866 0 01-1-.566 2.435 2.435 0 01-.639-.9 3.087 3.087 0 01-.219-1.206v-.018a3.135 3.135 0 01.237-1.242 2.924 2.924 0 01.694-.986 3.1 3.1 0 011.059-.639 3.724 3.724 0 011.37-.237 5.38 5.38 0 01.8.055 3.462 3.462 0 01.658.164 3.321 3.321 0 01.566.292 3.823 3.823 0 01.511.438 3.074 3.074 0 01.767 1.26 5.589 5.589 0 01.219.913 7.56 7.56 0 01.073 1.169v.018a7.473 7.473 0 01-.256 1.973 4.507 4.507 0 01-.731 1.516 3.5 3.5 0 01-1.206.986 3.707 3.707 0 01-1.662.347 4.163 4.163 0 01-1.662-.292 5 5 0 01-1.242-.749l1.023-1.48a3.667 3.667 0 00.913.566 2.463 2.463 0 001.003.205zm.311-3.014a1.6 1.6 0 001.114-.365 1.23 1.23 0 00.4-.95V45.7a1.257 1.257 0 00-.42-.968 1.622 1.622 0 00-1.151-.384 1.6 1.6 0 00-1.114.365 1.293 1.293 0 00-.384.968v.019a1.2 1.2 0 00.42.968 1.686 1.686 0 001.134.368z",
    transform: "translate(-85.39 -42.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M147.952 49.716h-4.311l-.311-1.37 4.859-5.626h1.644v5.425h1.187v1.571h-1.187v1.9h-1.863v-1.9zm0-1.589v-2.758l-2.352 2.758z",
    transform: "translate(-81.752 -42.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M151.588 51.76a4.482 4.482 0 01-1.352-.183 3.472 3.472 0 01-1.078-.511 2.294 2.294 0 01-.712-.8 2.2 2.2 0 01-.256-1.041V49.2a2.281 2.281 0 01.365-1.315 2.745 2.745 0 011.059-.822 2.56 2.56 0 01-.822-.767 2.1 2.1 0 01-.311-1.169v-.018a2.132 2.132 0 01.219-.95 2.319 2.319 0 01.639-.767 3.149 3.149 0 01.986-.511 4.006 4.006 0 011.279-.183 3.891 3.891 0 011.26.183 3.149 3.149 0 01.986.511 2.32 2.32 0 01.639.767 2.132 2.132 0 01.219.95v.018a1.924 1.924 0 01-.308 1.173 2.776 2.776 0 01-.822.767 3.247 3.247 0 011.041.822 1.923 1.923 0 01.384 1.26v.018a2.312 2.312 0 01-.256 1.1 2.348 2.348 0 01-.712.822 3.273 3.273 0 01-1.078.511 5.416 5.416 0 01-1.369.16zm0-1.607a1.894 1.894 0 001.133-.311.961.961 0 00.4-.785v-.018a.919.919 0 00-.42-.8 2.035 2.035 0 00-1.1-.292 1.849 1.849 0 00-1.1.292.9.9 0 00-.438.8v.018a.961.961 0 00.4.785 1.72 1.72 0 001.125.311zm0-3.745a1.315 1.315 0 00.913-.311 1.011 1.011 0 00.347-.767v-.018a.936.936 0 00-.329-.712 1.252 1.252 0 00-.932-.311 1.332 1.332 0 00-.932.311.936.936 0 00-.329.712v.018a1.015 1.015 0 00.347.785 1.4 1.4 0 00.915.293z",
    transform: "translate(-77.734 -42.645)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(112.397 15.6)",
    fill: "#020203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M115.258 40.038l1.279 8.4h.347l1.407-8.476 9.462-28.935h10.156l-18.34 49.741h-6.923L94.16 11.03h11.216z",
    transform: "translate(-94.16 -10.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M119.31 11.03h9.663v49.394h-9.663z",
    transform: "translate(-73.369 -10.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M157.179 60.424H126.71V11.03h9.663v40.79h20.806z",
    transform: "translate(-67.251 -10.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M172.588 49.639h-15.18l-3.745 10.942H144l17.774-49.741h7.126l17.774 49.741h-10.159zm-12.7-7.763h10.577L166.8 30.861l-1.48-7.763h-.347l-1.48 7.837z",
    transform: "translate(-52.957 -10.84)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M107.269 59.567A11.987 11.987 0 0190.975 56.3c-.018-.018-.018-.018-.018-.037l-1.023-1.754s-.018-.018 0-.018l-2.758-4.768L74.79 28.221a.018.018 0 00-.018-.018l-.712-1.243c-.037-.073-.073-.128-.11-.2A52.621 52.621 0 0049.308 6.008 47.379 47.379 0 0032.63 2.3l40.936 71.077 3.087 5.389.621 1.078a.064.064 0 00.018.037 11.845 11.845 0 0020.021-.347c.11-.183.219-.365.329-.566l3.178-5.535 7.2-12.513 2.758-4.8a11.294 11.294 0 01-3.509 3.447z",
    transform: "translate(-32.63 -2.3)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M67.345 26.692a1.091 1.091 0 01.11.2l.712 1.242a.018.018 0 00.018.018l12.385 21.5 2.1-3.672 2.83-4.912 1.169-2.028 1.1-1.882-4.658-8.074a.064.064 0 00-.018-.037L81.337 26A52.9 52.9 0 0054.96 5.21a46.746 46.746 0 00-14.34-2.85l2.064 3.58a52.667 52.667 0 0124.661 20.752z",
    transform: "translate(-26.025 -2.25)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M75.679 26.748l-.8 1.388c-.037.055-.073.128-.11.183l-5.082 8.841-1.1 1.882-1.169 2.028-2.831 4.914-2.1 3.672 2.758 4.768v.018l.986 1.717c0 .018 0 .018.018.037a12.044 12.044 0 0019.838-.164 12.335 12.335 0 00.877-1.5.018.018 0 01.018-.018L117.035 2.38C100.8 2.837 84.1 12.829 75.679 26.748z",
    transform: "translate(-7.945 -2.234)",
    fill: "url(#linear-gradient-3)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVila);
export default __webpack_public_path__ + "static/media/logo-vila.2d0bccc353ca3d30ce6f94b578e59181.svg";
export { ForwardRef as ReactComponent };